import type { CreateActivity } from './typings'
import type { ActivityDetails } from '../../../typings'

export const createActivityActionCreator = (
  payload?: ActivityDetails,
): CreateActivity => ({
  type: 'activities/create',
  payload,
})
